import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { Vertical } from 'atoms/layout/flex';
import { BodyL, DisplayL } from 'atoms/typography';
import { Img } from 'atoms/ui/Img';
import { Pictures } from 'components/landing/types';
import { useConnectionContext } from 'contexts/connection';
import { glossary } from 'lib/glossary';

const Root = styled(Vertical)`
  padding: calc(8 * var(--unit)) var(--double-unit);
  background-image: var(--backupField);
  background-image: var(--field);
  text-align: center;
  background-size: cover;
  background-position: center;
`;
const Header = styled(Vertical)`
  max-width: 392px;
`;

export type CompeteAssets = {
  field: Pictures;
  cards: Pictures;
};
type Props = {
  assets: CompeteAssets;
  title: ReactNode;
  description: ReactNode;
  promotion?: ReactNode;
};
export const Compete = ({ assets, title, description, promotion }: Props) => {
  const { signUp } = useConnectionContext();
  return (
    <Root
      gap={8}
      center
      style={
        {
          '--backupField': `url(${assets.field.pictureUrl})`,
          '--field': `image-set(url(${assets.field.avif}) type('image/avif'), url(${assets.field.pictureUrl}) type('image/jpeg'))`,
        } as CSSProperties
      }
    >
      <Header gap={3} center>
        <Vertical gap={2}>
          <DisplayL>{title}</DisplayL>
          <BodyL>{description}</BodyL>
        </Vertical>
        <Button color="secondary" size="medium" onClick={signUp}>
          <FormattedMessage {...glossary.playNow} />
        </Button>
      </Header>
      <picture>
        <source srcSet={assets.cards.avif} type="image/avif" />
        <Img
          src={assets.cards.pictureUrl}
          fetchpriority="low"
          width="543"
          height="661"
        />
      </picture>
      {promotion}
    </Root>
  );
};
